var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4To5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 132,
    viewBox: "0 0 38 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2929 131.707C29.6834 132.098 30.3166 132.098 30.7071 131.707L37.0711 125.343C37.4616 124.953 37.4616 124.319 37.0711 123.929C36.6805 123.538 36.0474 123.538 35.6568 123.929L30 129.586L24.3431 123.929C23.9526 123.538 23.3194 123.538 22.9289 123.929C22.5384 124.319 22.5384 124.953 22.9289 125.343L29.2929 131.707ZM-9.24762e-07 2L9.99986 2L9.99986 -1.74847e-06L-7.61671e-07 -2.62268e-06L-9.24762e-07 2ZM28.9999 21L29 131L31 131L30.9999 21L28.9999 21ZM9.99986 2C20.4933 2 28.9998 10.5066 28.9999 21L30.9999 21C30.9998 9.402 21.5978 -7.34542e-07 9.99986 -1.74847e-06L9.99986 2Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4To5);
export default __webpack_public_path__ + "static/media/step_4_to_5.60e0794db1e1d239631285d5881ff58d.svg";
export { ForwardRef as ReactComponent };